import { render } from "./CopyrightTopLink.vue?vue&type=template&id=35446ce6&scoped=true"
import script from "./CopyrightTopLink.vue?vue&type=script&lang=js"
export * from "./CopyrightTopLink.vue?vue&type=script&lang=js"

import "./CopyrightTopLink.vue?vue&type=style&index=0&id=35446ce6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35446ce6"]])

export default __exports__